import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ff0ef1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ratings" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentComment = _resolveComponent("ContentComment")!

  return (_openBlock(), _createElementBlock("ol", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ratingsList.ratings, (rate, index) => {
      return (_openBlock(), _createElementBlock("li", { key: index }, [
        _createVNode(_component_ContentComment, {
          tab: "Ratings",
          id: rate.id,
          comment: rate.message,
          date: rate.createdAt,
          "user-image": rate.userImage,
          "user-name": rate.userName,
          "user-i-d": rate.userID,
          stars: rate.stars,
          likes: rate.likes,
          rate: rate
        }, null, 8, ["id", "comment", "date", "user-image", "user-name", "user-i-d", "stars", "likes", "rate"])
      ]))
    }), 128)),
    (_ctx.ratingsList.haveRatings)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "rating__see-more",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadRatings(_ctx.ratingsList.ratings.length)))
        }, " Ver mais "))
      : _createCommentVNode("", true)
  ]))
}